import { Auth, IAuthToken } from '@shared/Auth';

export type ITileLoadFunctionOptions = {
    imageTile: any;
    src: string;
    providerType: string;
    uuid: string;
    authToken: string;
};

export async function tileLoadFunction(opts: ITileLoadFunctionOptions) {
    // Add auth headers
    const headers = {};
    if (opts.providerType === 'proxy' || opts.providerType === 'infrakitProvider') {
        const token: IAuthToken = await Auth.getToken();
        headers['authorization'] = `Bearer ${token.accessToken}`;
    }

    // Authenticated third party map tiles are fetched from proxy server
    if (opts.providerType === 'proxy') {
        opts.src = buildProxyUrl(opts.src, opts.uuid, opts.authToken);
    }

    const response = await fetch(opts.src, { headers });

    const blob = await response.blob();
    opts.imageTile['httpStatus'] = response.status;
    opts.imageTile.getImage().src = URL.createObjectURL(blob);
}

function buildProxyUrl(src: string, uuid: string, authToken: string): string {
    const url = new URL(src);
    const params = new URLSearchParams(url.search);
    params.set('project_uuid', kuura.getProjectUuid());

    if (uuid) {
        params.set('kuura_base_url', `https://${kuura.getServerDomain()}/kuura`);
        params.set('baselayer_uuid', uuid);
    } else if (authToken) {
        params.set('authToken', authToken);
    }

    return `${kuura.AwsApiGatewayDomain()}/map-proxy/v1${url.pathname}?${params}`;
}
